export default __webpack_public_path__ + "static/media/Zoria's Spire.ff91ce69.jpg";